import type { TypographyProps } from "@mui/material";
import { Typography, styled } from "@mui/material";

export const ContextIndicator = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0.75, 2),
}));

export const ContextIndicatorText = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
  }),
);
